import { useState } from 'react';

import { Chip, ChipOwnProps, Tooltip } from '@mui/material';
import { GridRowModel } from '@mui/x-data-grid-pro';

import { CarrinhoFalhasModal } from 'pages/compra/carrinho/components/modal/CarrinhoFalhasModal';

export function CarrinhoSituacaoColumn({ row }: { row: GridRowModel }) {
    const [openFalhasModal, setOpenFalhasModal] = useState<boolean>(false);
    const { pedidoLog, pedidoStatus } = row;

    let msgTooltip = null;
    let title = null;
    let color: ChipOwnProps['color'] = 'warning';

    if (pedidoStatus.idPedidoStatus === 19) {
        color = 'warning';
        title = 'Finalizando';
    } else if (pedidoLog) {
        color = 'error';
        title = 'Falha ao Finalizar';
        msgTooltip = 'Visualizar Falha';
    } else {
        color = 'info';
        title = 'Aguardando Finalizar';
    }

    return (
        <>
            <Tooltip title={msgTooltip || ''}>
                <Chip
                    label={title}
                    variant="outlined"
                    size="small"
                    color={color}
                    sx={{ width: '100%' }}
                    onClick={pedidoLog ? () => setOpenFalhasModal(true) : undefined}
                />
            </Tooltip>

            <CarrinhoFalhasModal open={openFalhasModal} setOpen={setOpenFalhasModal} falha={pedidoLog?.dsMensagem || ''} />
        </>
    );
}
